import MobileDetect from 'mobile-detect'
import { UAParser } from 'ua-parser-js'

const md = new MobileDetect(window.navigator.userAgent)
const rawOS = (md.os() || '').toLowerCase()
const os = rawOS === 'ios' ? rawOS : rawOS.slice(0, -2)
const isIpad = navigator.platform == 'MacIntel' && navigator.maxTouchPoints > 1
const browser = (md.userAgent() || '').toLowerCase()
const platform = md.tablet() || isIpad ? 'tablet' : md.mobile() ? 'mobile' : 'desktop'
const androidVendor = [
  'samsung',
  'xiaomi',
  'oppo',
  'vivo',
  'honor',
  'huawei',
  'one',
  'google',
  'motorola',
  'huawei',
  'lenovo',
  'poco',
  'asus',
  'realme',
  'nokia',
  'sony',
  'meizu',
  'zte',
]

const info = {
  browser,
  platform,
  os,
}

export const Device = {
  validate,
  isMobile,
  isDesktop,
  isSafari,
  isIOS,
  getDeviceModel,
}

function isSafari() {
  return browser === 'safari'
}
function isIOS() {
  return os === 'ios'
}

function isMobile() {
  return platform === 'mobile'
}

function isDesktop() {
  return false
}

function validate({ runtime }) {
  return !runtime || Object.entries(runtime).every(([key, value]) => value.includes(info[key]))
}

function getDeviceModel() {
  const parser = new UAParser()
  const result = parser.getResult()
  const os = result.os
  const browser = result.browser
  const deviceModel = {
    model: '',
    vendor: '',
    browser: '',
  }

  const device = result.device

  switch (os.name) {
    case 'iOS':
      // eslint-disable-next-line no-case-declarations
      const modelType = detectDeviceModel()
      deviceModel.model = modelType
      deviceModel.vendor = device.vendor
      break
    case 'Android':
      deviceModel.model = device.model
      if (device.vendor){
        const checkVendor = androidVendor.includes(device.vendor.toLowerCase())
        if (checkVendor){
          deviceModel.vendor = device.vendor
        }
        else{
          if (device.type === 'tablet'){
            deviceModel.vendor = 'AndroidTablet'
          }
          else{
            deviceModel.vendor = 'AndroidMobile'
          }
        }
      }
      else {
        if (device.type === 'tablet'){
          deviceModel.vendor = 'AndroidTablet'
        }
        else{
          deviceModel.vendor = 'AndroidMobile'
        }
      }

      break
    case 'Mac OS':
      deviceModel.model = device.model
      deviceModel.vendor = device.vendor
      break
    case 'Windows':
      deviceModel.model = os.version
      deviceModel.vendor = os.name
      break
    case 'Linux':
      deviceModel.model = os.version
      deviceModel.vendor = os.name
      break
    default:
      deviceModel.model = os.version
      deviceModel.vendor = os.name
  }
  if (browser.name){
    deviceModel.browser = browser.name
  }

  return deviceModel
}

function detectDeviceModel() {
  const width = window.screen.width
  const height = window.screen.height
  for (const model in DeviceDimensions) {
    if (DeviceDimensions.hasOwnProperty(model)) {
      const dimensions = DeviceDimensions[model]
      if (dimensions.width === width && dimensions.height === height) {
        return model
      }
    }
  }

  return 'iPhone'
}

const DeviceDimensions = {
  iPhoneSE: { width: 320, height: 568 },
  iPhone8: { width: 375, height: 667 },
  iPhone8Plus: { width: 414, height: 736 },
  iPhoneX: { width: 375, height: 812 },
  iPhone11: { width: 414, height: 896 },
  iPhone11Pro: { width: 375, height: 812 },
  iPhone11ProMax: { width: 414, height: 896 },
  iPhone12Mini: { width: 360, height: 780 },
  iPhone12: { width: 390, height: 844 },
  iPhone12Pro: { width: 390, height: 844 },
  iPhone12ProMax: { width: 428, height: 926 },
  iPhone13Mini: { width: 360, height: 780 },
  iPhone13: { width: 390, height: 844 },
  iPhone13Pro: { width: 390, height: 844 },
  iPhone13ProMax: { width: 428, height: 926 },
  iPhone14: { width: 393, height: 852 },
  iPhone14Pro: { width: 393, height: 852 },
  iPhone14ProMax: { width: 430, height: 932 },
  iPhone15: { width: 393, height: 852 },
  iPhone15Pro: { width: 393, height: 852 },
  iPhone15ProMax: { width: 430, height: 932 },
  iPadMini: { width: 768, height: 1024 },
  iPad: { width: 768, height: 1024 },
  iPadAir: { width: 820, height: 1180 },
  iPadPro11: { width: 834, height: 1194 },
  iPadPro12_9: { width: 1024, height: 1366 },
}
